module.exports = __webpack_public_path__ + "img/CM-CA-112122-Ford-Established.9f3fc229.jpg";